module.exports = __webpack_public_path__ + "img/ywLight.3bb1b85b.png";